import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  resetSigninManagerForm: null,
  updateSigninManagerField: ['field'],
});

export const SigninManagerFormTypes = Types;
export default Creators;
